const DownArrowIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <g
        id='Layer_2'
        data-name='Layer 2'
        transform='translate(0.163)'
      >
        <g
          id='invisible_box'
          data-name='invisible box'
          transform='translate(-0.163)'
        >
          <rect
            id='Rectangle_87'
            data-name='Rectangle 87'
            width='24'
            height='24'
            transform='translate(0)'
            fill='none'
          />
        </g>
        <g
          id='icons_Q2'
          data-name='icons Q2'
          transform='translate(5.122 7.868)'
        >
          <path
            id='Path_349'
            data-name='Path 349'
            d='M16.9,21.5l-5.226-5.226a.937.937,0,0,0-1.479.1,1.035,1.035,0,0,0,.1,1.331l5.916,5.867a.937.937,0,0,0,1.38,0L23.509,17.7a1.035,1.035,0,0,0,.1-1.331.937.937,0,0,0-1.479-.1Z'
            transform='translate(-10.001 -15.959)'
            fill='#202945'
          />
        </g>
      </g>
    </svg>
  );
};

export default DownArrowIcon;
